import React, { useState, useEffect } from 'react';

export const useCapsLockDetector = () => {
  const [isCapsLockOn, setIsCapsLockOn] = useState(false);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e && e.getModifierState && e.getModifierState('CapsLock')) {
        setIsCapsLockOn(true);
      } else {
        setIsCapsLockOn(false);
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    // window.addEventListener('keyup', handleKeyDown);


    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      // window.removeEventListener('keyup', handleKeyDown);

    };
  }, []);

  return isCapsLockOn;
};


